export const formatPrice = (price, numberOfDigit = 2) => {
  let number;
  if (typeof price === 'string') {
    if (price.includes('.') && price.includes(',')) {
      number = parseFloat(price.replace(/\./g, '').replace(',', '.'));
    } 
    else if (price.includes(',')) {
      number = parseFloat(price.replace(/\./g, '').replace(',', '.'));
    } 
    else {
      number = parseFloat(price);
    }
  } else {
    number = price;
  }

  if (isNaN(number)) {
    return '0,00';
  }

  const formatted = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: numberOfDigit,
    maximumFractionDigits: numberOfDigit
  }).format(number);

  return formatted;
};
